import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi, imgUrl } from "../lib/api";
import { CATEGORIES, fmtDate } from "../lib/format";
import { CategoryBadge } from "../components/site/CategoryBadge";

const FILTERS = [["", "Tümü"], ...Object.entries(CATEGORIES).map(([k, v]) => [k, v.label])];

export default function AnnouncementsPage({ fixed, title = "Tüm Duyurular" }) {
  const [cat, setCat] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], pages: 1 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setPage(1);
    setCat("");
  }, [fixed]);

  useEffect(() => {
    setLoading(true);
    publicApi.get("/public/announcements", { params: { category: fixed || cat || undefined, page } })
      .then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [fixed, cat, page]);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <p className="eyebrow text-[#E07A5F]">Pano</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-[#1B4332] mt-2" data-testid="announcements-title">{title}</h1>
      {!fixed && (
        <div className="flex flex-wrap gap-2 mt-8" data-testid="category-filters">
          {FILTERS.map(([k, label]) => (
            <button key={k || "all"} onClick={() => { setCat(k); setPage(1); }} data-testid={`filter-${k || "all"}`}
              className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${cat === k ? "bg-[#1B4332] text-white" : "bg-white border border-black/10 text-slate-600 hover:bg-[#D8F3DC]"}`}>
              {label}
            </button>
          ))}
        </div>
      )}
      <div className="mt-10 space-y-4">
        {loading && <p className="text-slate-500">Yükleniyor...</p>}
        {!loading && data.items.length === 0 && <p className="text-slate-500" data-testid="announcements-empty">Bu kategoride duyuru bulunmuyor.</p>}
        {!loading && data.items.map((a, i) => (
          <Link key={a.id} to={`/duyuru/${a.id}`} data-testid={`announcement-item-${a.id}`}
            className="group fade-up flex gap-5 bg-white rounded-3xl border border-black/5 p-4 sm:p-5 hover:shadow-[0_8px_32px_rgba(0,0,0,0.08)] transition-shadow"
            style={{ animationDelay: `${i * 40}ms` }}>
            {a.image_path && <img src={imgUrl(a.image_path)} alt="" className="hidden sm:block w-36 h-24 rounded-2xl object-cover" />}
            <div className="min-w-0">
              <div className="flex items-center gap-2"><CategoryBadge category={a.category} /><span className="text-xs text-slate-400">{fmtDate(a.date)}</span></div>
              <p className="mt-2 font-display text-lg font-semibold text-slate-800 group-hover:text-[#1B4332]">{a.title}</p>
              <p className="text-sm text-slate-500 line-clamp-2 mt-1">{a.content}</p>
            </div>
          </Link>
        ))}
      </div>
      {data.pages > 1 && (
        <div className="flex items-center justify-center gap-3 mt-10">
          <button disabled={page <= 1} onClick={() => setPage(page - 1)} className="px-4 py-2 rounded-full border bg-white disabled:opacity-40" data-testid="page-prev">Önceki</button>
          <span className="text-sm text-slate-500" data-testid="page-indicator">{page} / {data.pages}</span>
          <button disabled={page >= data.pages} onClick={() => setPage(page + 1)} className="px-4 py-2 rounded-full border bg-white disabled:opacity-40" data-testid="page-next">Sonraki</button>
        </div>
      )}
    </div>
  );
}
